export enum SelectingStage {
  SEARCHING = "searching",
  SETTING = "setting"
}
